/** Words the notification menus and dialog share (2026-10-29). */
import type { EffectiveNotificationLevel, MuteConfig, MuteDuration } from '@neosocial/protocol';
import { tr } from '../i18n';

/** A level's name. */
export function levelName(l: EffectiveNotificationLevel): string {
  const { t } = tr();
  return l === 0 ? t('nt.all') : l === 2 ? t('nt.nothing') : t('nt.mentions');
}

/** "Muted until Today at 15:15", or "Until you turn it back on". */
export function mutedUntil(cfg: MuteConfig | null | undefined): string {
  const { t, fmt } = tr();
  return cfg?.end_time
    ? t('nt.until', { time: fmt.stamp(new Date(cfg.end_time)) })
    : t('nt.untilOn');
}

/** Discord's mute lengths, in its order. */
export const DURATIONS: readonly MuteDuration[] = [900, 3600, 10800, 28800, 86400, -1];

/** "For 15 minutes" … "Until I turn it back on". */
export function durationLabel(w: MuteDuration): string {
  const { t } = tr();
  switch (w) {
    case 900:
      return t('nt.dur.15m');
    case 3600:
      return t('nt.dur.1h');
    case 10800:
      return t('nt.dur.3h');
    case 28800:
      return t('nt.dur.8h');
    case 86400:
      return t('nt.dur.24h');
    default:
      return t('nt.dur.forever');
  }
}
